import React from 'react';
import Mobile from '../asset-class-filter-components/mobile';

export default function Filters(props) {
  return (
    <Mobile {...props} />
  );
}
